// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"93e3fc64","905":"9e268c4b"}[chunkId] + ".chunk.js";
};